import React from 'react';
import './projects.css';
import finance from '../../assets/finance.png';
import makeup from '../../assets/icon32.jpg';
import freelance from '../../assets/community.png';
import space from '../../assets/space-card.png';


const Projects = () => {
  return (
    <section id="projects" className="py-3 py-md-5">
    <div className="container-lg">
      <div className="text-center mt-5">
        <h2>PORTFOLIO</h2>
    </div>

    <div className="mt-2 row d-flex justify-content-around">
        <div className="mt-4 col-md-4 col-sm-10 col-xs-12">
          <div className="card">
            <img className="card-img-top" src={space} alt="expense"/>
            <div className="card-body text-center">
              <h5 className="card-title">Twinkling Stars Academy</h5>
              <p className="card-text text-center">A Portfolio Website of Astronomy classes for kids</p>
              <p className="card-text fw-bold">Tech Stack: ReactJS, Bootstrap</p>
              <a href="https://twinklingstars-academy.netlify.app/" target="_blank" rel="noreferrer"  className="btn btn-outline-secondary my-2">Visit Website</a>
            </div>
          </div>
        </div>

        <div className="mt-4 col-md-4 col-sm-10 col-xs-12">
          <div className="card">
            <img className="card-img-top" /* style={{ width: "100%", height: "18.9vw", objectFit: "contain" }} */ src={makeup} alt="food"/>
            <div className="card-body text-center">
              <h5 className="card-title">Pinkinn Makeover</h5>
              <p className="card-text text-center">A Portfolio Website of a Makeup Artist</p>
              <p className="card-text fw-bold">Tech Stack: ReactJS</p>
              <a href="https://pinkinn-makeover.netlify.app/" target="_blank" rel="noreferrer" className="btn btn-outline-secondary my-2">Visit Website</a>
            </div>
          </div>
        </div>

        <div className="mt-4 col-md-4 col-sm-10 col-xs-12">
          <div className="card">
            <img className="card-img-top" /* style={{ width: "100%", height: "18.9vw", objectFit: "contain" }} */ src={finance} alt="finance"/>
            <div className="card-body text-center">
              <h5 className="card-title">Budget Buddy</h5>
              <p className="card-text text-center">Manage your Income and Expense better with this app</p>
              <p className="card-text fw-bold">Tech Stack: ReactJS, ChartJS, MaterialUI</p>
              <a href="https://your-budget-buddy.netlify.app/" target="_blank" rel="noreferrer" className="btn btn-outline-secondary my-2">Visit Website</a>
            </div>
          </div>
        </div>

        {/* <div className="mt-4 col-md-4 col-sm-10 col-xs-12">
          <div className="card">
            <img className="card-img-top" src={freelance} alt="freelance" />
            <div className="card-body text-center">
              <h5 className="card-title">Freelancer's community</h5>
              <p className="card-text text-center">A dedicated platform to interact with freelancers</p>
              <p className="card-text fw-bold">Tech Stack: ReactJS, NodeJS</p>
              <a href="https://freelancing-community.netlify.app/" target="_blank" rel="noreferrer" className="btn btn-outline-secondary mt-2 mb-1">Visit Website</a>
            </div>
          </div>
        </div> */}

    </div>
    </div>
</section>

  )
}

export default Projects